// @ts-strict-ignore
export type SlackChannelsList = {
  team_id: string;
  channels: SlackChannel[];
};

export type SlackChannel = {
  name: string;
  id: string;
};

export type SelectedChannelsChangedDetail = {
  teamId: string;
  selectedChannels: SlackChannel[];
};

export type SlackChannelListError = {
  status;
  type;
  error;
};

export enum SlackAuthProblem {
  NoSlackAuthException = `NoSlackAuthException`,
  MissingSlackAuthScopesException = `MissingSlackAuthScopesException`,
}
